export default "__VITE_ASSET__aa6382ec__"